/*
 * 头部消息
 * author: v_xmdjliu
 * time: 2019-03-25
 */
import React, { PureComponent } from "react"
import { autorun } from "mobx"
import { observer } from "mobx-react"
import noticeStore from "../store/index"
import messageStore from "./store/index"
import announcementService from "./services/announcement"
import { Loading, PageBar, Empty } from "@tencent/spaui"
import { reportUserBehaviorCgi } from "@/api/operator/cgi/smb/common"
import { withRouter } from "react-router-dom"

// 收件箱
@withRouter
@observer
export default class Announcement extends PureComponent {
  noticeChangeUnsubscribe = null // 监听通知更新的监听器

  componentDidMount() {
    // 监听通知数据更改
    this.noticeChangeUnsubscribe = autorun(() => {
      if (noticeStore.noticeReadedId) {
        announcementService.noticeReadedMark(noticeStore.noticeReadedId)
      }
    })
    announcementService.getNoticeList(false)
    $("#msgs").on("click", "a", function (e) {
      const href = $(this).attr("href")
      const param = {
        behavior: "打开链接",
        page1: "公告中心",
        page2: $(this).attr("href"),
      }
      reportUserBehaviorCgi({ data: param })
      window.open(href, "_blank", "noopener")
      return false
    })
  }
  componentWillUnmount() {
    if (this.noticeChangeUnsubscribe) {
      this.noticeChangeUnsubscribe()
    }
  }

  // 自定义 提示
  render() {
    const { config } = messageStore.messageAnnouncementStore
    const { list = [], loadingShow = false } = messageStore.messageAnnouncementStore.announcementData
    return (
      <>
        <div
          style={{
            zIndex: 1000,
            position: "absolute",
            background: "rgba(255,255,255,0)",
            width: "100%",
            height: "100%",
            display: loadingShow ? "block" : "none",
          }}
        >
          <Loading display="center" />
        </div>
        <ul className="msgs" id="msgs">
          {list.length ? (
            list.map((x) => (
              <li key={x.id} className={`msg-item${x.is_read != 1 ? " unread" : ""}`} onClick={() => announcementService.handleOpen(x.id, x.is_read, x.title)}>
                <div className="msg-info" onClick={() => this.props.history.push(`/agency/notice/${x.id}`)} type="span">
                  <span className="msg-via">{x.category_name}</span>
                  <span className="msg-title">{x.title}</span>
                  <span className="msg-time">{x.valid_begin_time}</span>
                </div>
              </li>
            ))
          ) : (
            <Empty title="暂无消息" />
          )}
        </ul>
        <div className="inbox-card-footer">
          <PageBar type="mini" value={config.page} pageSize={config.pageSize} totalSize={messageStore.messageAnnouncementStore.announcementData.conf?.total_num || 0} onChange={(event, value) => announcementService.handlePagesChange(value)} />
        </div>
      </>
    )
  }
}
